// extracted by mini-css-extract-plugin
module.exports = {"details":"DisplayOfferUserDetails_details__2egrO","name":"DisplayOfferUserDetails_name__6cpRb"};